

































































































































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import { dataList, boxList } from "@/components/listData";
import tabs from "./components/tabs.vue";
import { getEngine } from "@/req/homes";
import download from "./components/download.vue";
import reagister from "../../components/reagister.vue";
import authCodeSearch from "./components/authCodeSearch.vue";
import { dataModel } from "./engine";
import securityVerification from "../../components/securityVerification.vue";
@Component({
  components: {
    tabs,
    download,
    reagister,
    authCodeSearch,
    securityVerification,
  },
})
export default class Home extends Vue {
  public activeIndex: any = 1;
  public visible = false;
  public selectModel = {};
  public dataModel: any = dataModel;
  public dataList = dataList;
  public created() {
    this.getEngineList();
    if (this.$route.query.tab) {
      const selectIndex: any = this.$route.query.tab;
      this.activeIndex = Number(selectIndex);
      this.selectModel = this.dataModel[selectIndex - 1];
    } else {
      this.selectModel = this.dataModel[this.activeIndex - 1];
    }
    // if (this.activeIndex == 2) {
    //   this.visible = true;
    // }
  }
  public async getEngineList() {
    const res = await getEngine();
    if (res.code == 200) {
      const obj = Object.assign({}, res.data);
      res.data.forEach((its) => {
        if (its.engine_list && its.engine_list.length) {
          its.engine_list.forEach((itd) => {
            itd.list.forEach((element) => {
              element.timer = this.$fn.toViewDates(element.update_time * 1000);
            });
          });
        }
        this.dataModel.forEach((item, index) => {
          if (its.engine_type == item.id) {
            item.downloadInfo = its.engine_list;
          }
        });
        this.dataModel[0].downloadInfo = [
          {
            name_type: 2,
            name: "引擎下载(HUB工具)",
            mark: "引擎 底板 说明书 集成常用工具",
            list: [{
              id: 31,
              engine: "996传奇引擎多端版",
              engine_type: 1,
              name: "引擎下载",
              name_type: 2,
              edition: "HUB下载",
              edition_type: 0,
              edition_number: "",
              download_link: "https://cdnjc.dhsf.huiyuehz.com/996Hub/996Hub.zip",
              operation_user: "caoyuan",
            }]
          },
          {
            name_type: 1,
            name: "演示服",
            mark: "可以直接进游戏体验下引擎产品",
            list: [{
              id: 30,
              engine: "996传奇引擎多端版",
              engine_type: 1,
              name: "游戏客户端下载",
              name_type: 1,
              edition: "演示服下载",
              edition_type: 0,
              edition_number: "",
              download_link: "https://static.dhsf.huiyuehz.com/Package/promote/57e449b0ec916028fb7912ea6299e8b0.apk?v=1755227736",
              operation_user: "caoyuan",
            }]
          }
        ]
        this.dataModel[4].downloadInfo = [
          {
            name_type: 2,
            name: "引擎下载(HUB工具)",
            mark: "引擎 底板 说明书 集成常用工具",
            list: [{
              id: 49,
              engine: "996传奇3引擎多端版",
              engine_type: 5,
              name: "引擎下载",
              name_type: 2,
              edition: "HUB下载",
              edition_type: 0,
              edition_number: "",
              download_link: "https://996box-static.oss-accelerate.aliyuncs.com/offical/static/app/1779353368000_zemTE.zip",
              operation_user: "caoyuan",
              timer: "2026-05-21",
            }]
          },
          {
            name_type: 2,
            name: "演示服",
            mark: "可以直接进游戏体验下引擎产品",
            list: [{
              id: 50,
              engine: "996传奇3引擎多端版",
              engine_type: 1,
              name: "引擎下载",
              name_type: 2,
              edition: "演示版本下载",
              edition_type: 0,
              edition_number: "",
              download_link: "https://www.996m2.com/versionCenter",
              operation_user: "caoyuan",
              timer: "2026-05-21",
            }]
          }
        ]
      });
    }
  }
  public confirmed() {
    this.visible = false;
  }
  public linkToDevelopers() {
    window.open(
      "http://pure-engine.996yinqing.com/#/login",
      "_blank"
    );
  }
  public applicationCourse() {
    window.open(
      "https://docs.qq.com/doc/DWmVpUklPVENWRXdU",
      "_blank"
    );
  }
  public download(id) {
    const $securityVerification = (this as any).$refs.securityVerification;
    $securityVerification.show(id);
  }
  public registerBtn() {
    const $register = (this as any).$refs.register;
    $register.show();
  }
  public addBoxDownload(item) {
    if (item.state == 1) {
      window.open(
        "https://static.dhsf.xqhuyu.com/offical" + item.link,
        item.target
      );
    }
    if (item.state == 2) {
      window.open(item.link, item.target);
    }
    if (item.state == 3) {
      window.open(item.link, item.target);
    }
    if (item.state == 4) {
      window.open(item.link, item.target);
    }
  }
  public selectCateRow(row) {
    this.activeIndex = row.id;
    this.selectModel = row;
    // if (this.activeIndex == 2) {
    //   this.visible = true;
    // }
  }
  public authCodeSearch() {
    window.open("/certificateInquiry", "_blank");
    // const $authCodeSearch = (this as any).$refs.authCodeSearch;
    // $authCodeSearch.show();
  }
}
